import React from 'react';
import ResultTable from "../ResultTable/ResultTable";
import Hash from "object-hash";
import { getFields } from "../../../../web/Utils/utils";
import { NoResourceMessage, RelativeDiv, SearchInput, TableWrapper } from "./PlaylistComponents/PlaylistComponents";

export const PlaylistByTabs = (props ) => {
    const { tabs, filteredTabs, selectedTab, handleSearch, searchTerm, setSearchTerm, isUnifiedTable, session } = props;

    let fieldsExcludes = ['filename', 'filesize', 'entityBundle', 'vIframe', 'entityChanged', 'entityCreated', "description", "tags"];
    if (process.env.REACT_APP_SEE_VERSION !== "1") {
        fieldsExcludes.push("version");
    }

    let fieldsToShowSelected = []
    if (selectedTab && selectedTab.files && selectedTab.files[0] && selectedTab.files[0].metadata) {
        fieldsToShowSelected = getFields(selectedTab.files[0].metadata, fieldsExcludes)
    }

    const getFieldsTabs = (tab) => {
        if (tab && tab.files[0] && tab.files[0].metadata) {
            return getFields(tab.files[0].metadata, fieldsExcludes)
        }

        return []
    }

    return (
      <RelativeDiv>
          <SearchInput
              type="text"
              placeholder='Filter by name or description (e.g., "Manual").'
              onChange={ ( e ) => {
                  setSearchTerm(e.target.value);
                  handleSearch(e.target.value);
              }}
              value={searchTerm}
          />
          {selectedTab ? (
              <TableWrapper>
                  <ResultTable
                      rowWidth={80}
                      key={Hash(JSON.stringify(selectedTab))}
                      centered
                      fieldsToShow={fieldsToShowSelected}
                      title={selectedTab.title}
                      data={searchTerm ? selectedTab.files.filter(file =>
                          file.metadata.filename.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          (file.metadata.description && file.metadata.description.toLowerCase().includes(searchTerm.toLowerCase()))
                      ) : selectedTab.files}
                      type={"playlist"}
                      tableUnified={isUnifiedTable}
                      session={session}
                  />
              </TableWrapper>
          ) : (
              (filteredTabs || tabs) && (filteredTabs || tabs).map(tab => {
                  return (
                      <TableWrapper id="tableWrapper" key={Hash(JSON.stringify(tab))}>
                          <ResultTable
                              rowWidth={80}
                              key={Hash(JSON.stringify(tab))}
                              centered
                              fieldsToShow={getFieldsTabs(tab)}
                              title={tab.title}
                              data={tab.files}
                              type={"playlist"}
                              tableUnified={isUnifiedTable}
                          />
                      </TableWrapper>
                  )
              })
          )}
          {filteredTabs && filteredTabs.length === 0 && searchTerm && (
              <NoResourceMessage>
                  No resources found for "{searchTerm}". Try adjusting your search or clearing the filter to see all available resources.
              </NoResourceMessage>
          )}
      </RelativeDiv>
  );
}
